<template>
  <div class="m-map">
    <!-- 新增站点弹框 -->
    <div class="show-hide">
      <div class="hide-c" :style="{left:nLeft+'px',top:nTop+'px'}">
        <div class="hd-t">{{!isAdd?"编辑站点":"新增站点"}}</div>
        <div class="hd-c">
          <el-form
            :model="formLabelAlign"
            :rules="rules"
            ref="formLabelAlign"
            :label-position="labelPosition"
            label-width="85px"
          >
            <el-form-item label=" " prop="companyName">
              <el-input v-model="formLabelAlign.companyKey" class="label-i" maxlength="10"></el-input>
              <el-input v-model="formLabelAlign.companyName" maxlength="50" @input="changeinput"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="cityName">
              <el-input v-model="formLabelAlign.cityKey" class="label-i" maxlength="10"></el-input>
              <el-input v-model="formLabelAlign.cityName" maxlength="20" @input="changeinput"></el-input>
            </el-form-item>
            <el-form-item label="销 量" prop="sale" class="sale-i">
              <el-input
                v-model="formLabelAlign.sale"
                maxlength="20"
                onkeyup="this.value=this.value.replace(/\D/g,'')"
                onafterpaste="this.value=this.value.replace(/\D/g,'')"
                @input="changeinput"
              ></el-input>
              <span class="sale-s">升 / 天</span>
            </el-form-item>
            <el-form-item label="经纬度" prop="coordinateX">
              <el-input v-model="formLabelAlign.coordinateX" maxlength="50" @input="changeinput"></el-input>
            </el-form-item>
            <el-form-item label="备注" class="mark-l">
              <el-input type="textarea" maxlength="100" v-model="formLabelAlign.remarks"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="hd-b">
          <div @click="giveUp">取消</div>
          <div @click="savePos('formLabelAlign')" :class="isWrite?'aa12 aa':'aa12'">确定</div>
        </div>
        <!-- <div class="close-hide">
          <i @click="giveUp" class="el-icon-close"></i>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/api/road.js'
import { constants } from 'crypto'
export default {
  data() {
    return {
      isWrite: false,
      labelPosition: 'left',
      rules: {
        companyName: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        cityName: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        sale: [{ required: true, message: '请输入销量', trigger: 'blur' }],
        coordinateX: [
          { required: true, message: '请输入经纬度', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    nLeft: Number,
    nTop: Number,
    isAdd: Boolean,
    formLabelAlign: Object
  },
  watch: {
    isAdd(val, oldVal) {
      this.isAdd = val
    }
  },
  created() {
    if (this.formLabelAlign.coordinateArr) {
      this.formLabelAlign.coordinateX =
        this.formLabelAlign.coordinateArr[0] +
        ',' +
        this.formLabelAlign.coordinateArr[1]
      var parse1 = JSON.parse(this.formLabelAlign.companyName)
      var parse2 = JSON.parse(this.formLabelAlign.cityName)
      this.formLabelAlign.companyKey = parse1.companyKey
      this.formLabelAlign.companyName = parse1.companyName
      this.formLabelAlign.cityKey = parse2.cityKey
      this.formLabelAlign.cityName = parse2.cityName

      this.isWrite = true
    } else {
      this.formLabelAlign.companyKey = '集 团'
      this.formLabelAlign.cityKey = '位 置'
    }
  },
  methods: {
    changeinput() {
      var data = this.formLabelAlign
      if (data.companyName && data.sale && data.cityName && data.coordinateX) {
        this.isWrite = true
      } else {
        this.isWrite = false
      }
    },
    giveUp() {
      this.$emit('giveUp')
    },
    // 保存站点
    savePos(formLabelAlign) {
      this.$refs[formLabelAlign].validate(valid => {
        if (valid) {
          if (!this.formLabelAlign.companyKey || !this.formLabelAlign.cityKey) {
            this.$message({
              message: "请输入标题",
              type: 'warning'
            })
            return
          }
          var _this = this
          var coordinateX = this.formLabelAlign.coordinateX
          var arrData = coordinateX.split(',')
          this.formLabelAlign.longitude = arrData[0]
          this.formLabelAlign.latitude = arrData[1]
          delete this.formLabelAlign.coordinateX
          var data1 = {
            companyName: this.formLabelAlign.companyName,
            companyKey: this.formLabelAlign.companyKey
          }

          var data2 = {
            cityName: this.formLabelAlign.cityName,
            cityKey: this.formLabelAlign.cityKey
          }

          delete this.formLabelAlign.companyKey
          delete this.formLabelAlign.companyName
          delete this.formLabelAlign.companyKey
          delete this.formLabelAlign.cityName

          this.formLabelAlign.companyName = data1
          this.formLabelAlign.cityName = data2
          if (this.isAdd) {
            axios.addSite(this.formLabelAlign).then(e => {
              if (e.code == 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                _this.$emit('confirmAddSite')
              } else {
                this.$message({
                  message: e.message,
                  type: 'warning'
                })
              }
            })
          } else {
            axios.modifySide(this.formLabelAlign).then(e => {
              if (e.code == 200) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                })
                _this.$emit('confirmAddSite')
              } else {
                this.$message({
                  message: e.message,
                  type: 'warning'
                })
              }
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="css" scope>
.show-hide {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
.hide-c {
  width: 350px;
  position: absolute;
  margin: 0 auto;
  background: #2b304c;
  border: 1px solid #3c4161;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.hd-t {
  background: #444a67;
  font-size: 14px;
  border-radius: 8px 8px 0 0;
  color: #ffffff;
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.hd-b {
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.hd-b div {
  display: inline-block;
  background: #383a54;
  border-radius: 2px;
  font-size: 12px;
  color: #ffffff;
  width: 170px;
  height: 35px;
  text-align: center;
  margin-bottom: 10px;
  line-height: 35px;
}
.aa12 {
  margin-left: 20px;
}
.hd-b div.aa {
  background-image: linear-gradient(-90deg, #2daaff 2%, #5a74fc 98%);
  border-radius: 2px;
}
.hd-c {
  padding: 20px 20px 0px 20px;
}
.hd-c .el-form-item {
  margin-bottom: 10px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 2px;
}
.sale-s {
  position: absolute;
  color: #ffffff;
  right: 5px;
}
.show-hide .el-form-item__error {
  font-size: 10px;
  top: 5px;
  left: unset;
  right: 5px;
  text-align: right;
  width: 105px;
}
.hd-c .aaa {
  background: none;
}
.hd-c .el-form-item__label {
  font-size: 12px;
  padding-left: 13px;
  color: rgba(255, 255, 255, 0.5);
}
.hd-c .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.hd-c .el-input__inner,
.hd-c .el-textarea__inner {
  background-color: transparent;
  padding-left: 0;
  resize: none;
  color: #ffffff;
  border: 0;
}

.close-hide {
  position: absolute;
  top: 100px;
  left: 101%;
}
.close-hide .el-icon-close {
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
}
.close-hide .el-icon-close:hover {
  cursor: pointer;
}
.el-form-item__content .label-i {
  position: absolute;
  width: 60px;
  left: -60px;
}
.hd-c .label-i .el-input__inner {
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
}
.sale-i .el-form-item__error{
  right: 50px;
}
</style>